var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57 27",
    style: {
      enableBackground: "new 0 0 57 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st0",
    d: "M11.9,0C14.3,0,16,2,16,4.5l0,0V26h-4.1C9.6,26,8,24.1,8,21.7l0,0V8.8H4.3  C1.9,8.8,0,6.8,0,4.4C0,2,1.9,0,4.3,0l0,0H11.9z M53,18c2.2,0,4,1.8,4,4s-1.8,4-4,4c-2.2,0-4-1.8-4-4S50.8,18,53,18z M33,0l0.2,0  C35.3,0.1,37,2,37,4.4l0,0V26h-4.1c-2.2,0-3.9-1.9-3.9-4.3l0,0V4.4C29,2,30.8,0,33,0L33,0z M43,0l0.2,0C45.3,0.1,47,2,47,4.4l0,0V26  h-4.1c-2.2,0-3.9-1.9-3.9-4.3l0,0V4.4C39,2,40.8,0,43,0L43,0z M22,11l0.2,0c2.1,0.1,3.8,2,3.8,4.2l0,0V26H22c-2.2,0-3.9-1.9-3.9-4.2  l0,0v-6.6C18,12.9,19.8,11,22,11L22,11z M22,0c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4s-4-1.8-4-4C18,1.8,19.8,0,22,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTill);
export default __webpack_public_path__ + "static/media/till.387ffb2bc18966ebf41b6e84f63114bd.svg";
export { ForwardRef as ReactComponent };